__turbopack_context__.v({
  "body": "Modal-module-scss-module__ws1CfW__body",
  "closeBtn": "Modal-module-scss-module__ws1CfW__closeBtn",
  "fadeIn": "Modal-module-scss-module__ws1CfW__fadeIn",
  "footer": "Modal-module-scss-module__ws1CfW__footer",
  "header": "Modal-module-scss-module__ws1CfW__header",
  "lg": "Modal-module-scss-module__ws1CfW__lg",
  "md": "Modal-module-scss-module__ws1CfW__md",
  "modal": "Modal-module-scss-module__ws1CfW__modal",
  "overlay": "Modal-module-scss-module__ws1CfW__overlay",
  "slideUp": "Modal-module-scss-module__ws1CfW__slideUp",
  "sm": "Modal-module-scss-module__ws1CfW__sm",
  "title": "Modal-module-scss-module__ws1CfW__title",
});
